import { ReactNode } from 'react';
import styled from 'styled-components';
import { H4, Body2 } from 'ui/theme';

const Section = styled.section`
  background-color: ${({ theme }) => theme.colors.backgroundColors.backgroundPrimary};
  border: solid 1px ${({ theme }) => theme.colors.neutrals.grey15};
  border-radius: 10px;
  width: 100%;
  padding: ${({ theme }) => theme.spacing.utils.pxToRem(24)};
  &:not(:first-child) {
    margin-top: ${({ theme }) => theme.spacing.utils.pxToRem(32)};
  }
`;

const Title = styled(H4)`
  margin-bottom: 0;
`;

const ScrollAnchor = styled.a<{ scrollAnchorOffset: number }>`
  display: block;
  position: relative;
  height: 1px;
  top: ${({ scrollAnchorOffset }) => `${scrollAnchorOffset}px`};
  visibility: hidden;
`;

const Description = styled(Body2)`
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
`;

const Content = styled.div`
  margin-top: ${({ theme }) => theme.spacing.utils.pxToRem(24)};
`;

type Props = {
  children?: ReactNode;
  id: string;
  headingText: string;
  descriptionText: string;
  scrollAnchorOffset?: number;
};

export const FormSection = ({
  children,
  id,
  headingText,
  descriptionText,
  scrollAnchorOffset = -175,
}: Props) => (
  <Section>
    <Title>{headingText}</Title>
    <ScrollAnchor id={id} scrollAnchorOffset={scrollAnchorOffset} />
    <Description>{descriptionText}</Description>
    <Content>{children}</Content>
  </Section>
);
